import { Component, OnInit } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { MenuService } from './app.menu.service';
import { PrimeNGConfig } from 'primeng/api';
import { AuthService } from './auth/auth.service';
import { RadioButtonClickEvent } from 'primeng/radiobutton';
import { Router } from '@angular/router';

@Component({
    selector: 'app-main',
    templateUrl: './app.main.component.html',
    animations: [
        trigger('mask-anim', [
            state('void', style({
                opacity: 0
            })),
            state('visible', style({
                opacity: 0.8
            })),
            transition('* => *', animate('250ms cubic-bezier(0, 0, 0.2, 1)'))
        ])
    ]
})
export class AppMainComponent {

    menuClick: boolean = false;

    userMenuClick: boolean = false;

    topbarUserMenuActive: boolean = false;

    horizontal = true;

    menuActive: boolean = false;

    menuHoverActive: boolean = false;

    topbarColor = 'layout-topbar-blue';

    menuColor = 'layout-menu-light';

    themeColor = 'blue';

    layoutColor = 'blue';

    topbarSize = 'large';

    configDialogActive: boolean = false;

    inputStyle = 'outlined';

    ripple = true;

    compactMode = false;

    constructor(private menuService: MenuService, private primengConfig: PrimeNGConfig, private authService: AuthService, private router: Router) {}

    blockBodyScroll(): void {
        if (document.body.classList) {
            document.body.classList.add('blocked-scroll');
        } else {
            document.body.className += ' blocked-scroll';
        }
    }

    unblockBodyScroll(): void {
        if (document.body.classList) {
            document.body.classList.remove('blocked-scroll');
        } else {
            document.body.className = document.body.className.replace(new RegExp('(^|\\b)' +
                'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    }

    onWrapperClick() {
        if (!this.menuClick) {
            this.menuActive = false;

            if (this.horizontal) {
                this.menuService.reset();
            }

            this.menuHoverActive = false;
            this.unblockBodyScroll();
        }

        if (!this.userMenuClick) {
            this.topbarUserMenuActive = false;
        }

        this.userMenuClick = false;
        this.menuClick = false;
    }

    onMenuButtonClick(event: MouseEvent) {
        this.menuClick = true;

        if (!this.horizontal || this.isMobile()) {
            this.menuActive = !this.menuActive;

            if (this.menuActive) {
                this.blockBodyScroll();
            } else {
                this.unblockBodyScroll();
            }
        }

        event.preventDefault();
    }

    onTopbarUserMenuButtonClick(event: any) {
        this.userMenuClick = true;
        this.topbarUserMenuActive = !this.topbarUserMenuActive;

        event.preventDefault();
    }

    onTopbarUserMenuClick(event: MouseEvent) {
        this.userMenuClick = true;

        const target = event.target as HTMLElement;
        if (target && target.nodeName === 'A' || (target.parentNode && target.parentNode.nodeName === 'A')) {
            this.topbarUserMenuActive = false;
        }
    }

    onTopbarSubItemClick(event: Event , item: string) {
        event.preventDefault();
        if (item === 'logout') {
            this.router.navigate(['/logout']);
        }
    }

    onSidebarClick(event: Event) {
        this.menuClick = true;
    }

    isMobile() {
        return window.innerWidth <= 1024;
    }

    isTablet() {
        const width = window.innerWidth;
        return width <= 1024 && width > 640;
    }

    onRippleChange(event: any) {
        this.ripple = event.checked;
        this.primengConfig.ripple = event.checked;
    }

    changeTopbarTheme(event: Event, color: string) {
        this.topbarColor = 'layout-topbar-' + color;

        event.preventDefault();
    }

    changeMenuToHorizontal(event: Event, mode: boolean) {
        this.horizontal = mode;

        event.preventDefault();
    }

    changeMenuTheme(event: any, color: string) {
        this.menuColor = 'layout-menu-' + color;

        event.preventDefault();
    }

    changeThemeStyle(event: any, compactMode: boolean) {
        let href;
        const themeLink: HTMLLinkElement = document.getElementById('theme-css') as HTMLLinkElement;
        if (compactMode) {
            href = 'assets/theme/' + 'theme-' + this.themeColor + '-compact.css';
        }
        else {
            href = 'assets/theme/' + 'theme-' + this.themeColor + '.css';
        }

        this.replaceLink(themeLink, href);

        event.preventDefault();
    }

    changeComponentTheme(event: Event, theme: string) {
        let href;
        this.themeColor = theme;
        const themeLink: HTMLLinkElement = document.getElementById('theme-css') as HTMLLinkElement;

        if (this.compactMode) {
            href = 'assets/theme/' + 'theme-' + this.themeColor + '-compact.css';
        }
        else {
            href = 'assets/theme/' + 'theme-' + this.themeColor + '.css';
        }

        this.replaceLink(themeLink, href);

        event.preventDefault();
    }

    changePrimaryColor(event: Event, color: string) {
        this.layoutColor = color;
        const layoutLink: HTMLLinkElement = document.getElementById('layout-css') as HTMLLinkElement;
        const href = 'assets/layout/css/layout-' + color + '.css';

        this.replaceLink(layoutLink, href);

        event.preventDefault();
    }

    isIE() {
        return /(MSIE|Trident\/|Edge\/)/i.test(window.navigator.userAgent);
    }

    replaceLink(linkElement: HTMLLinkElement, href: string) {
        if (this.isIE()) {
            linkElement.setAttribute('href', href);
        } else {
            const id = linkElement.getAttribute('id');
            const cloneLinkElement = linkElement.cloneNode(true) as HTMLLinkElement;
            const parentNode = linkElement.parentNode;

            if (parentNode) {
                parentNode.insertBefore(cloneLinkElement, linkElement.nextSibling);

                cloneLinkElement.addEventListener('load', () => {
                    linkElement.remove();
                    cloneLinkElement.setAttribute('id', id || '');
                });
            }
        }
    }
}
